import React, { createContext, useCallback, useEffect, useState, useMemo } from "react";
import { blogFetcher, paginate } from "../api/requests";

const BlogContext = createContext();

const BlogContextProvider = ({ children }) => {
  const [blogCategories, setBlogCategories] = useState([]);
  const [blogTags, setBlogTags] = useState([]);
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [paginationInfo, setPaginationInfo] = useState({});

  const updateBlogCategories = useCallback((newData) => {
    setBlogCategories(newData);
  },[]);

  const updateBlogTags = useCallback((newData) => {
    setBlogTags(newData);
  }, []);

  const updateBlogPosts = useCallback((newData) => {
    setBlogPosts(newData);
  }, []);
  const updateTotalCount = useCallback((newData) => {
    setTotalCount(newData);
  },[]);
  const updatePaginationInfo = useCallback((newData) => {
    setPaginationInfo(newData);
  }, []);

  const handlePageChange = useCallback(async (arg) => {
    setLoading(true);

    try {
      let res;

      if (typeof arg === "string") {
        let path = arg;
        try {
          if (arg.startsWith("http")) {
            const u = new URL(arg);
            path = `${u.pathname}${u.search}`;
          }
        } catch (_) {}

        if (path.startsWith("/")) path = path.slice(1);
        if (path.startsWith("api/")) path = path.slice(4);

        res = await paginate.get(path);
      } else if (typeof arg === "object" && arg.baseUrl && arg.page) {
        res = await paginate.getByNumber(arg.baseUrl, arg.page);
      } else {
        res = arg;
      }

      setBlogPosts(res);
      setPaginationInfo(res);
      setTotalCount(res.count);
    } catch (error) {
      console.error("Error fetching page:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let isActive = true;

    const load = async () => {
      try {
        setLoading(true);

        const [res, categories, tags] = await Promise.all([
          blogFetcher.getAll(),
          blogFetcher.getCtegories(),
          blogFetcher.getTags(),
        ]);

        if (!isActive) return;
        setBlogPosts(res);
        setTotalCount(res.count);
        setPaginationInfo(res);
        setBlogCategories(categories);
        setBlogTags(tags);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    load();
    return () => {
      isActive = false;
    };
  }, []);

  const contextValue = useMemo(
    () => ({
      blogCategories,
      updateBlogCategories,
      blogTags,
      updateBlogTags,
      blogPosts,
      updateBlogPosts,
      loading,
      setLoading,
      totalCount,
      updateTotalCount,
      updatePaginationInfo,
      paginationInfo,
      handlePageChange,
    }),
    [
      blogCategories,
      blogTags,
      blogPosts,
      loading,
      totalCount,
      paginationInfo,
      handlePageChange,
    ]
  );
  

  return (
    <BlogContext.Provider value={contextValue}>{children}</BlogContext.Provider>
  );
};

export { BlogContext, BlogContextProvider };
